"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f117 = void 0;
exports.f117 = {
    "ua": [
        16,
        1604,
        1606,
        2093,
        2747,
        3337,
        3338,
        3549,
        6616,
        6619,
        7931,
        7937
    ],
    "ukarãngmã": [
        22
    ],
    "us": [
        23,
        80,
        127,
        193,
        256,
        260,
        261,
        378,
        379,
        380,
        381,
        391,
        401,
        442,
        448,
        463,
        464,
        502,
        506,
        922,
        1008,
        1331,
        1408,
        1439,
        1443,
        1446,
        1449,
        1450,
        1451,
        1455,
        1456,
        1460,
        1466,
        1467,
        1475,
        1476,
        1482,
        1509,
        1523,
        1534,
        1570,
        1571,
        1577,
        1581,
        1601,
        1603,
        1616,
        1618,
        1626,
        1638,
        1642,
        1649,
        1650,
        1655,
        1657,
        1666,
        1690,
        1731,
        1801,
        1806,
        2111,
        2112,
        2118,
        2146,
        2147,
        2283,
        2291,
        2296,
        2297,
        2298,
        2299,
        2305,
        2325,
        2396,
        2466,
        2567,
        2813,
        2882,
        2907,
        2939,
        3027,
        3032,
        3041,
        3085,
        3102,
        3177,
        3178,
        3207,
        3214,
        3226,
        3230,
        3562,
        3673,
        3679,
        3683,
        3719,
        3723,
        3764,
        3871,
        3928,
        3964,
        4003,
        4035,
        4139,
        4143,
        4371,
        4415,
        4418,
        4461,
        4477,
        4523,
        4536,
        4604,
        4706,
        4782,
        4791,
        4802,
        4820,
        4843,
        4862,
        4952,
        4962,
        4978,
        5041,
        5043,
        5142,
        5151,
        5238,
        5357,
        5414,
        5584,
        5611,
        5628,
        5629,
        5677,
        5698,
        5709,
        5721,
        5752,
        5756,
        5770,
        5826,
        5844,
        5904,
        5937,
        5969,
        5970,
        6032,
        6035,
        6039,
        6082,
        6090,
        6093,
        6097,
        6103,
        6146,
        6153,
        6211,
        6220,
        6257,
        6259,
        6263,
        6310,
        6327,
        6373,
        6377,
        6396,
        6402,
        6406,
        6435,
        6453,
        6660,
        6778,
        6791,
        6836,
        6854,
        6882,
        6909,
        6912,
        6915,
        6946,
        6951,
        7005,
        7059,
        7301,
        7320,
        7356,
        7430,
        7431,
        7432,
        7438,
        7506,
        7517,
        7568,
        7569,
        7647,
        7656,
        7686,
        7693,
        7782,
        7795,
        7799,
        7818,
        7823,
        7956,
        7974,
        8023,
        8073,
        8122,
        8148,
        8150,
        8160,
        8162,
        8167,
        8229,
        8239,
        8243,
        8260,
        8300,
        8382,
        8410,
        8431,
        8569,
        8603,
        8624,
        8636,
        8681,
        8691,
        8728,
        8864,
        8876,
        8921,
        8927,
        8931,
        8933,
        8937,
        9041,
        9064,
        9177,
        1770,
        2221
    ],
    "united states": [
        23,
        80,
        127,
        193,
        256,
        260,
        261,
        378,
        379,
        380,
        381,
        391,
        401,
        442,
        448,
        463,
        464,
        502,
        506,
        922,
        1008,
        1331,
        1408,
        1439,
        1443,
        1446,
        1449,
        1450,
        1451,
        1455,
        1456,
        1460,
        1466,
        1467,
        1475,
        1476,
        1482,
        1509,
        1523,
        1534,
        1570,
        1571,
        1577,
        1581,
        1601,
        1603,
        1616,
        1618,
        1626,
        1638,
        1642,
        1649,
        1650,
        1655,
        1657,
        1666,
        1690,
        1731,
        1801,
        1806,
        2111,
        2112,
        2118,
        2146,
        2147,
        2283,
        2291,
        2296,
        2297,
        2298,
        2299,
        2305,
        2325,
        2396,
        2466,
        2567,
        2813,
        2882,
        2907,
        2939,
        3027,
        3032,
        3041,
        3085,
        3102,
        3177,
        3178,
        3207,
        3214,
        3226,
        3230,
        3562,
        3673,
        3679,
        3683,
        3719,
        3723,
        3764,
        3871,
        3928,
        3964,
        4003,
        4035,
        4139,
        4143,
        4371,
        4415,
        4418,
        4461,
        4477,
        4523,
        4536,
        4604,
        4706,
        4782,
        4791,
        4802,
        4820,
        4843,
        4862,
        4952,
        4962,
        4978,
        5041,
        5043,
        5142,
        5151,
        5238,
        5357,
        5414,
        5584,
        5611,
        5628,
        5629,
        5677,
        5698,
        5709,
        5721,
        5752,
        5756,
        5770,
        5826,
        5844,
        5904,
        5937,
        5969,
        5970,
        6032,
        6035,
        6039,
        6082,
        6090,
        6093,
        6097,
        6103,
        6146,
        6153,
        6211,
        6220,
        6257,
        6259,
        6263,
        6310,
        6327,
        6373,
        6377,
        6396,
        6402,
        6406,
        6435,
        6453,
        6660,
        6778,
        6791,
        6836,
        6854,
        6882,
        6909,
        6912,
        6915,
        6946,
        6951,
        7005,
        7059,
        7301,
        7320,
        7356,
        7430,
        7431,
        7432,
        7438,
        7506,
        7517,
        7568,
        7569,
        7647,
        7656,
        7686,
        7693,
        7782,
        7795,
        7799,
        7818,
        7823,
        7956,
        7974,
        8023,
        8073,
        8122,
        8148,
        8150,
        8160,
        8162,
        8167,
        8229,
        8239,
        8243,
        8260,
        8300,
        8382,
        8410,
        8431,
        8569,
        8603,
        8624,
        8636,
        8681,
        8691,
        8728,
        8864,
        8876,
        8921,
        8927,
        8931,
        8933,
        8937,
        9041,
        9064,
        9177
    ],
    "united": [
        23,
        24,
        80,
        127,
        193,
        256,
        260,
        261,
        321,
        378,
        379,
        380,
        381,
        391,
        401,
        407,
        442,
        448,
        460,
        463,
        464,
        502,
        506,
        700,
        703,
        740,
        750,
        751,
        922,
        1008,
        1019,
        1331,
        1378,
        1408,
        1439,
        1443,
        1446,
        1449,
        1450,
        1451,
        1455,
        1456,
        1460,
        1466,
        1467,
        1475,
        1476,
        1482,
        1509,
        1523,
        1534,
        1558,
        1570,
        1571,
        1577,
        1581,
        1601,
        1603,
        1616,
        1618,
        1626,
        1638,
        1642,
        1649,
        1650,
        1655,
        1657,
        1666,
        1690,
        1703,
        1705,
        1708,
        1709,
        1731,
        1801,
        1806,
        1840,
        1916,
        1933,
        2111,
        2112,
        2118,
        2121,
        2134,
        2146,
        2147,
        2153,
        2210,
        2216,
        2218,
        2234,
        2283,
        2291,
        2296,
        2297,
        2298,
        2299,
        2305,
        2325,
        2389,
        2396,
        2466,
        2567,
        2573,
        2628,
        2700,
        2730,
        2749,
        2813,
        2845,
        2882,
        2898,
        2901,
        2907,
        2909,
        2925,
        2939,
        2956,
        3027,
        3032,
        3041,
        3067,
        3085,
        3102,
        3177,
        3178,
        3191,
        3207,
        3214,
        3226,
        3230,
        3238,
        3255,
        3374,
        3391,
        3526,
        3531,
        3533,
        3535,
        3561,
        3562,
        3673,
        3679,
        3683,
        3689,
        3693,
        3719,
        3723,
        3744,
        3764,
        3871,
        3905,
        3928,
        3955,
        3964,
        4003,
        4023,
        4035,
        4072,
        4132,
        4139,
        4143,
        4195,
        4371,
        4415,
        4418,
        4461,
        4477,
        4523,
        4536,
        4592,
        4604,
        4706,
        4757,
        4759,
        4762,
        4763,
        4764,
        4765,
        4770,
        4782,
        4791,
        4802,
        4820,
        4823,
        4843,
        4862,
        4952,
        4962,
        4978,
        4984,
        5041,
        5043,
        5142,
        5151,
        5171,
        5178,
        5202,
        5203,
        5238,
        5357,
        5364,
        5365,
        5367,
        5414,
        5434,
        5435,
        5474,
        5479,
        5495,
        5530,
        5584,
        5609,
        5611,
        5628,
        5629,
        5638,
        5673,
        5674,
        5677,
        5687,
        5698,
        5709,
        5715,
        5721,
        5752,
        5756,
        5770,
        5775,
        5799,
        5811,
        5826,
        5838,
        5844,
        5892,
        5904,
        5937,
        5969,
        5970,
        6006,
        6032,
        6035,
        6039,
        6055,
        6082,
        6090,
        6093,
        6097,
        6103,
        6146,
        6153,
        6162,
        6185,
        6211,
        6220,
        6257,
        6259,
        6263,
        6267,
        6310,
        6327,
        6373,
        6377,
        6396,
        6402,
        6406,
        6435,
        6453,
        6495,
        6524,
        6544,
        6563,
        6574,
        6585,
        6621,
        6624,
        6638,
        6639,
        6660,
        6661,
        6701,
        6703,
        6706,
        6731,
        6778,
        6780,
        6791,
        6836,
        6854,
        6882,
        6909,
        6912,
        6915,
        6946,
        6951,
        7005,
        7048,
        7059,
        7130,
        7136,
        7193,
        7194,
        7205,
        7223,
        7224,
        7234,
        7235,
        7301,
        7320,
        7356,
        7357,
        7430,
        7431,
        7432,
        7438,
        7506,
        7517,
        7568,
        7569,
        7636,
        7647,
        7656,
        7686,
        7693,
        7710,
        7782,
        7795,
        7799,
        7818,
        7823,
        7879,
        7956,
        7974,
        8023,
        8073,
        8082,
        8086,
        8122,
        8144,
        8148,
        8150,
        8160,
        8162,
        8167,
        8179,
        8180,
        8181,
        8229,
        8239,
        8243,
        8246,
        8260,
        8262,
        8300,
        8366,
        8382,
        8410,
        8431,
        8561,
        8569,
        8595,
        8603,
        8624,
        8636,
        8681,
        8691,
        8728,
        8864,
        8876,
        8877,
        8921,
        8927,
        8931,
        8933,
        8937,
        8979,
        8980,
        9012,
        9023,
        9041,
        9056,
        9057,
        9064,
        9177
    ],
    "united republic of tanzania": [
        24,
        460,
        700,
        703,
        740,
        1019,
        1378,
        1703,
        1705,
        1840,
        1916,
        1933,
        2216,
        2389,
        2700,
        2730,
        2749,
        2845,
        2898,
        2901,
        2909,
        2925,
        2956,
        3067,
        3191,
        3238,
        3255,
        3374,
        3391,
        3526,
        3531,
        3533,
        3535,
        3561,
        3689,
        3693,
        3744,
        3905,
        3955,
        4023,
        4132,
        4195,
        4592,
        4757,
        4759,
        4762,
        4763,
        4764,
        4765,
        4770,
        4823,
        4984,
        5171,
        5178,
        5202,
        5203,
        5364,
        5365,
        5367,
        5434,
        5435,
        5474,
        5479,
        5495,
        5530,
        5609,
        5638,
        5687,
        5715,
        5775,
        5799,
        5811,
        5892,
        6055,
        6162,
        6267,
        6495,
        6524,
        6574,
        6585,
        6621,
        6624,
        6638,
        6639,
        6661,
        6701,
        6703,
        6706,
        6780,
        7048,
        7130,
        7193,
        7194,
        7205,
        7223,
        7224,
        7234,
        7235,
        7357,
        7636,
        7879,
        8082,
        8086,
        8144,
        8179,
        8180,
        8181,
        8246,
        8366,
        8561,
        8979,
        8980,
        9012,
        9056,
        9057
    ],
    "uab meto": [
        366,
        29
    ],
    "uab": [
        366,
        29,
        908
    ],
    "ug": [
        66,
        93,
        1435,
        2217,
        2852,
        3190,
        3519,
        3540,
        3541,
        3572,
        3863,
        3897,
        4202,
        4296,
        4297,
        4300,
        4301,
        4361,
        4497,
        4511,
        4519,
        4774,
        5252,
        5372,
        5733,
        5800,
        5801,
        5802,
        6617,
        6618,
        6640,
        7003,
        7227,
        7421,
        7428,
        7570,
        7764,
        7923,
        8577
    ],
    "uganda": [
        4202,
        6640,
        66,
        93,
        1435,
        2217,
        2852,
        3190,
        3519,
        3540,
        3541,
        3572,
        3863,
        3897,
        4296,
        4297,
        4300,
        4301,
        4361,
        4497,
        4511,
        4519,
        4774,
        5252,
        5372,
        5733,
        5800,
        5801,
        5802,
        6617,
        6618,
        7003,
        7227,
        7421,
        7428,
        7570,
        7764,
        7923,
        8577
    ],
    "un": [
        88,
        6133,
        6134,
        6135
    ],
    "umbertana": [
        104
    ],
    "unyamootha": [
        104
    ],
    "upper egypt arabic": [
        118
    ],
    "upper": [
        8681,
        1482,
        1902,
        1914,
        3058,
        4035,
        7264,
        7320,
        7551,
        7655,
        7762,
        118,
        358,
        473,
        895,
        1541,
        1577,
        2795,
        3229,
        3481,
        4111,
        4112,
        5272,
        5396,
        5513,
        5937,
        6168,
        6264,
        6947,
        7165,
        7168,
        7363,
        8109,
        8150,
        8260,
        8927,
        5405
    ],
    "umo": [
        123
    ],
    "utugwang-irungene-afrike": [
        138
    ],
    "unietti": [
        147
    ],
    "uguano": [
        150
    ],
    "uitáte": [
        214
    ],
    "ukpet-ehom": [
        235
    ],
    "unangam tunnu": [
        260,
        261
    ],
    "unangam": [
        260,
        261
    ],
    "unangan": [
        260,
        261
    ],
    "unangany": [
        260,
        261
    ],
    "unangax": [
        260,
        261
    ],
    "unanghan": [
        260,
        261
    ],
    "ugbe": [
        262
    ],
    "uge": [
        262
    ],
    "umoreo": [
        291
    ],
    "umoriu": [
        291
    ],
    "umorrdak": [
        291
    ],
    "united kingdom": [
        321,
        750,
        751,
        1558,
        1708,
        1709,
        2134,
        2153,
        2210,
        2234,
        2573,
        2628,
        4072,
        5673,
        5674,
        5838,
        6006,
        6185,
        6544,
        6563,
        6731,
        7710,
        8262,
        8595,
        8877,
        9023
    ],
    "umbra": [
        334
    ],
    "upper managalasi": [
        358
    ],
    "uab atoni pah meto": [
        366,
        908
    ],
    "uab pah meto": [
        366,
        908
    ],
    "uhitische": [
        382
    ],
    "utinsche": [
        382
    ],
    "united arab emirates": [
        407,
        2121,
        7136
    ],
    "uruku": [
        450
    ],
    "urukú": [
        450
    ],
    "urumi": [
        8008,
        450
    ],
    "upper asaro": [
        473
    ],
    "uase": [
        485
    ],
    "uasi": [
        485
    ],
    "uasilau": [
        485
    ],
    "uruak": [
        507
    ],
    "urutaní": [
        507
    ],
    "ushi": [
        515
    ],
    "usi": [
        515
    ],
    "uzhil": [
        515
    ],
    "uzhili": [
        515
    ],
    "uzbeki": [
        531,
        8044
    ],
    "uzbeki arabic": [
        531
    ],
    "uz": [
        531,
        1605,
        3455,
        3456,
        3457,
        7444,
        8038,
        8040,
        8042
    ],
    "uzbekistan": [
        531,
        1605,
        3455,
        3456,
        3457,
        7444,
        8038,
        8040,
        8042
    ],
    "ulpma": [
        569
    ],
    "uwu": [
        577
    ],
    "udun": [
        637
    ],
    "uneapa": [
        647
    ],
    "unea": [
        647
    ],
    "uwet": [
        652
    ],
    "utse": [
        717
    ],
    "utser": [
        717
    ],
    "utseu": [
        717
    ],
    "uhei kachlakan": [
        803,
        7161
    ],
    "uhei": [
        803,
        7161
    ],
    "uhei-kaclakin": [
        803
    ],
    "uhei-kahlakim": [
        803
    ],
    "uriai": [
        812
    ],
    "upper tor": [
        895
    ],
    "uab metô": [
        908
    ],
    "uki": [
        909,
        915
    ],
    "ujuwa": [
        1087
    ],
    "ugi": [
        1177,
        1178
    ],
    "utudnon": [
        1219
    ],
    "ubaghara": [
        1273
    ],
    "urbanos": [
        1315
    ],
    "ukopinõpõna": [
        1353
    ],
    "umawa": [
        1354
    ],
    "urcibar": [
        1363
    ],
    "upper chehalis": [
        1482
    ],
    "ucokwe": [
        1484
    ],
    "upper ladakhi": [
        1541
    ],
    "uppu": [
        1542
    ],
    "uppu chin": [
        1542
    ],
    "ucayali": [
        1594,
        1563,
        1585,
        6426
    ],
    "upper coquille": [
        1577
    ],
    "ucayali-yurúa": [
        1585
    ],
    "ucayali ashéninca": [
        1585
    ],
    "ucayali-yurúa ashéninka": [
        1585
    ],
    "ukraine": [
        1604,
        1606,
        2093,
        2747,
        3337,
        3338,
        3549,
        6616,
        6619,
        7931,
        7937
    ],
    "usila": [
        1682
    ],
    "usila chinantec": [
        1682
    ],
    "uslar": [
        1740
    ],
    "urundi": [
        1751,
        6566,
        6567,
        7608
    ],
    "ururi": [
        1751,
        7608
    ],
    "upi": [
        1754,
        1755
    ],
    "u.s. virgin islands": [
        1770,
        2221
    ],
    "uina": [
        1810
    ],
    "umúkomasá": [
        1810
    ],
    "upper kinabatangan": [
        1902
    ],
    "upper grand valley dani": [
        1914
    ],
    "ure": [
        1993
    ],
    "umiray": [
        1998
    ],
    "umiray agta": [
        1998
    ],
    "umiray dumaget agta": [
        1998
    ],
    "umirey dumagat": [
        1998
    ],
    "umirey": [
        1998
    ],
    "uyajitaya": [
        2004
    ],
    "uyaji": [
        2004
    ],
    "urum": [
        8028,
        8029,
        2090,
        2091,
        2093
    ],
    "um": [
        2218
    ],
    "united states minor outlying islands": [
        2218
    ],
    "uy": [
        2284,
        7925
    ],
    "uruguay": [
        6328,
        6330,
        2284,
        7925
    ],
    "uqabniqput ieupiatun": [
        2291
    ],
    "uqabniqput": [
        2291
    ],
    "uvbie": [
        2319
    ],
    "uvhria": [
        2319
    ],
    "uvwie": [
        2319
    ],
    "uzekwe": [
        2328
    ],
    "ulster": [
        2504,
        2505,
        2506
    ],
    "uarequena": [
        2512
    ],
    "uerequema": [
        2512
    ],
    "urequema": [
        2512
    ],
    "umanakaina": [
        2589
    ],
    "umanikaina": [
        2589
    ],
    "ut-ma’in": [
        2607
    ],
    "ut-ma'in": [
        2607
    ],
    "uncu": [
        2632
    ],
    "uncunwee": [
        2632
    ],
    "umar": [
        2743,
        3614,
        3634
    ],
    "umari": [
        2743,
        3634
    ],
    "ufiomi": [
        2749
    ],
    "upper alemannic": [
        2795
    ],
    "uáira": [
        2805
    ],
    "uanana": [
        2828
    ],
    "uanano": [
        2828
    ],
    "ukusi-koparamio hoyahoya": [
        2930
    ],
    "ukusi-koparamio": [
        2930
    ],
    "u ní": [
        3004
    ],
    "u": [
        8032,
        3004,
        9110
    ],
    "uni": [
        7972,
        3004,
        3037
    ],
    "urdu": [
        7987,
        7988,
        7989,
        7990,
        7991,
        3013
    ],
    "upper lusatian": [
        3058
    ],
    "upper sorbian": [
        3058
    ],
    "uhorsʹkyy": [
        3070,
        3071
    ],
    "ungarisch": [
        3070,
        3071
    ],
    "utsat": [
        3086
    ],
    "utset": [
        3086
    ],
    "uitoto": [
        3090
    ],
    "ubani": [
        3126
    ],
    "utaha": [
        3149
    ],
    "unege": [
        3154
    ],
    "uzo": [
        3271,
        3172
    ],
    "uukturausingit": [
        3185
    ],
    "ugu": [
        3209,
        7900,
        7901,
        7902
    ],
    "ungo": [
        3209
    ],
    "ungu": [
        4253,
        8366,
        3209
    ],
    "urban indian sign language": [
        3224
    ],
    "urban": [
        3224
    ],
    "upper irumu": [
        3229
    ],
    "uso": [
        3271
    ],
    "ugal": [
        3297
    ],
    "ugare": [
        3297
    ],
    "ugarə": [
        3297
    ],
    "ubach": [
        3324
    ],
    "ubdé": [
        3437
    ],
    "upper adyghe": [
        3481
    ],
    "upper circassian": [
        3481
    ],
    "ukaan": [
        3511
    ],
    "uboi": [
        3515
    ],
    "uen": [
        3542
    ],
    "urukerebe": [
        3561
    ],
    "ukele": [
        3585
    ],
    "ukelle": [
        3585
    ],
    "ungorri": [
        3629
    ],
    "uaçá": [
        3630
    ],
    "urama-kope": [
        3690
    ],
    "uluveu": [
        3786
    ],
    "uliveo": [
        3786
    ],
    "uhula": [
        3825
    ],
    "urang": [
        3944
    ],
    "uranw": [
        3944
    ],
    "uraon": [
        3944
    ],
    "urau": [
        3944
    ],
    "uraw": [
        3944
    ],
    "uare": [
        3963
    ],
    "ulada": [
        4017
    ],
    "upper kuskokwim": [
        4035
    ],
    "ulipe": [
        4040
    ],
    "ukwese": [
        4090
    ],
    "upper khmer": [
        4111,
        4112
    ],
    "usilele": [
        4276
    ],
    "uyalipa pii": [
        4282
    ],
    "uyalipa": [
        4282
    ],
    "ung": [
        4313
    ],
    "usiai": [
        4378
    ],
    "ulaolinja": [
        4437
    ],
    "ulaolinya": [
        4437
    ],
    "ulumbu": [
        4454
    ],
    "utara": [
        4598
    ],
    "uled djemma": [
        4655,
        4656
    ],
    "uled": [
        4655,
        4656
    ],
    "utagha": [
        4694,
        4695
    ],
    "ujung pandang indonesian": [
        4725
    ],
    "ujung": [
        4725
    ],
    "ulu": [
        4735,
        9089
    ],
    "uta’": [
        4754
    ],
    "ulingan": [
        4777
    ],
    "uncoded languages": [
        4811
    ],
    "uncoded": [
        4811
    ],
    "usa": [
        4952,
        7430
    ],
    "upriver yuman": [
        4978
    ],
    "upriver": [
        4978
    ],
    "ubielo": [
        5020
    ],
    "udai": [
        5032,
        5033
    ],
    "una": [
        5107
    ],
    "uchilla-shimi": [
        5130
    ],
    "umbangala": [
        5211
    ],
    "ubili": [
        5217
    ],
    "umua": [
        5253
    ],
    "upper mori": [
        5272
    ],
    "ungwai": [
        5303
    ],
    "ungwe": [
        5303
    ],
    "upper mangdep": [
        5396
    ],
    "ugie": [
        5429
    ],
    "ungie": [
        5429
    ],
    "uri": [
        8034,
        5502
    ],
    "upper mbo": [
        5513
    ],
    "uw alngam": [
        5557
    ],
    "uw": [
        7788,
        5557,
        7618
    ],
    "ururagwe": [
        5638
    ],
    "ungom": [
        5663
    ],
    "ungomo": [
        5663
    ],
    "unza": [
        5666
    ],
    "ulunyankole": [
        5800
    ],
    "ulunyankore": [
        5800
    ],
    "upale": [
        5802
    ],
    "uilta": [
        5822
    ],
    "ujlta": [
        5822
    ],
    "ulta": [
        5822
    ],
    "up": [
        5824
    ],
    "ukfwo": [
        5887
    ],
    "uku": [
        5887
    ],
    "ulkulu": [
        5894
    ],
    "umanhan": [
        5904
    ],
    "umaua": [
        5907
    ],
    "utarmbung": [
        5912
    ],
    "utarmbu": [
        5912
    ],
    "umurano": [
        5916
    ],
    "unua": [
        5934
    ],
    "upper piman": [
        5937
    ],
    "uriya": [
        5948,
        5949
    ],
    "utkali": [
        5948,
        5949
    ],
    "ulunchun": [
        5954
    ],
    "urmar": [
        5960
    ],
    "urmuri": [
        5960
    ],
    "uud danum": [
        5982
    ],
    "uud": [
        5982
    ],
    "uut danum": [
        5982
    ],
    "uut": [
        5982
    ],
    "utoro": [
        5990
    ],
    "ubi": [
        7897,
        5999
    ],
    "uighur": [
        6001,
        6002,
        7916,
        7917,
        7918,
        7919,
        8748,
        8749,
        8941
    ],
    "uomo": [
        6038
    ],
    "uzá’": [
        6096
    ],
    "uhothha": [
        6145
    ],
    "uwotjüja": [
        6145
    ],
    "uaiana": [
        6157,
        8173
    ],
    "uaicana": [
        6157
    ],
    "uaikena": [
        6157
    ],
    "uainana": [
        6157
    ],
    "urubu-tapuya": [
        6157
    ],
    "upper pokomo": [
        6168
    ],
    "upper guinea crioulo": [
        6264
    ],
    "uma": [
        6270,
        6584,
        7954,
        8514
    ],
    "uruguayan portuguese": [
        6328,
        6330
    ],
    "uruguayan": [
        7925,
        6328,
        6330
    ],
    "uluna": [
        6350
    ],
    "unión": [
        6447
    ],
    "uluragooli": [
        6459
    ],
    "ungrike romá": [
        6542
    ],
    "ungrike": [
        6542
    ],
    "uruund": [
        6568
    ],
    "ucanja kamuku": [
        6583
    ],
    "ucanja": [
        6583
    ],
    "urogo": [
        6583
    ],
    "urunyaruanda": [
        6635,
        6636
    ],
    "ullans": [
        6731
    ],
    "ulster-scotch": [
        6731
    ],
    "ulster-scots": [
        6731
    ],
    "ut": [
        6733
    ],
    "umpqua": [
        8681,
        6882
    ],
    "ume": [
        6908
    ],
    "ubmejensámien giella": [
        6908
    ],
    "ubmejensámien": [
        6908
    ],
    "ume sami": [
        6908
    ],
    "umesamisk": [
        6908
    ],
    "umesamiska": [
        6908
    ],
    "uumajansaame": [
        6908
    ],
    "upper schlesisch": [
        6947
    ],
    "ubian": [
        6972
    ],
    "usamba": [
        6986
    ],
    "urule": [
        7003
    ],
    "uyobe": [
        7047
    ],
    "ushama": [
        7075
    ],
    "uya": [
        8021,
        7138
    ],
    "uhei kaclakin": [
        7161
    ],
    "uhei kahlakim": [
        7161
    ],
    "upper stieng": [
        7165
    ],
    "upper morehead": [
        7168,
        7363
    ],
    "urushubi": [
        7193
    ],
    "ulau-suain": [
        7216
    ],
    "use": [
        7245
    ],
    "upper saxon": [
        7264
    ],
    "upper tanana": [
        7320
    ],
    "uari": [
        7328
    ],
    "uruachi": [
        7373
    ],
    "upper necaxa totonac": [
        7551
    ],
    "u’wa": [
        7616,
        7788
    ],
    "uairã": [
        7617
    ],
    "ufaina": [
        7617
    ],
    "uw cuwa": [
        7788,
        7618
    ],
    "upper taromi": [
        7655
    ],
    "umatilla-tenino": [
        7686
    ],
    "usipi mrung": [
        7714,
        7715
    ],
    "usipi": [
        7714,
        7715
    ],
    "upper ta'oih": [
        7762
    ],
    "utapinõmakãphõná": [
        7787
    ],
    "uwa-tunebo": [
        7788
    ],
    "utee": [
        7837
    ],
    "uriankhai": [
        7875
    ],
    "uriankhai-monchak": [
        7875
    ],
    "uryankhai": [
        7875
    ],
    "uryankhai-monchak": [
        7875
    ],
    "uamué": [
        7893
    ],
    "uaripi": [
        7895
    ],
    "ubang": [
        7896
    ],
    "ubir": [
        7899
    ],
    "ubiri": [
        7899
    ],
    "umbu-ungu": [
        7900,
        7901,
        7902
    ],
    "ubu ugu": [
        7900,
        7901,
        7902
    ],
    "ubu": [
        7900,
        7901,
        7902
    ],
    "umbongu": [
        7900,
        7901,
        7902
    ],
    "ubykh": [
        7903,
        7904
    ],
    "ubyx": [
        7903,
        7904
    ],
    "uda": [
        7905
    ],
    "udihe": [
        7906
    ],
    "ude": [
        7906
    ],
    "udege": [
        7906
    ],
    "udegei": [
        7906
    ],
    "udegej": [
        7906
    ],
    "udeghe": [
        7906
    ],
    "udehe": [
        7906
    ],
    "udekhe": [
        7906
    ],
    "udige": [
        7906
    ],
    "udighe": [
        7906
    ],
    "udi": [
        7908
    ],
    "udin": [
        7908
    ],
    "uti": [
        7908
    ],
    "udin muz": [
        7908
    ],
    "ujir": [
        7909
    ],
    "udjir": [
        7909
    ],
    "udlam": [
        7910
    ],
    "uldeme": [
        7910
    ],
    "uzam": [
        7910
    ],
    "uzlam": [
        7910
    ],
    "udmurt": [
        7911,
        7912
    ],
    "uduk": [
        7913
    ],
    "ufim": [
        7915
    ],
    "uyghur": [
        7916,
        7917,
        7918,
        7919
    ],
    "uighuir": [
        7916,
        7917,
        7918,
        7919
    ],
    "uiguir": [
        7916,
        7917,
        7918,
        7919
    ],
    "uigur": [
        7916,
        7917,
        7918,
        7919
    ],
    "uygur": [
        7916,
        7917,
        7918,
        7919,
        8748,
        8749
    ],
    "ugaritic": [
        7920
    ],
    "ughele": [
        7922
    ],
    "ugele": [
        7922
    ],
    "ugandan sign language": [
        7923
    ],
    "ugandan": [
        7923
    ],
    "usl": [
        7923,
        7937
    ],
    "ugong": [
        7924
    ],
    "ugawng": [
        7924
    ],
    "uruguayan sign language": [
        7925
    ],
    "uruguaya": [
        7925
    ],
    "uhami": [
        7926
    ],
    "uhunduni": [
        7927
    ],
    "uisai": [
        7928
    ],
    "uive": [
        7929
    ],
    "ujijili": [
        7930
    ],
    "ukrainian": [
        7931,
        7937
    ],
    "ucrainean": [
        7931
    ],
    "ukraiński": [
        7931
    ],
    "ukrán": [
        7931
    ],
    "ukuriguma": [
        7933
    ],
    "ukhwejo": [
        7934
    ],
    "ukwedjo": [
        7934
    ],
    "ukrainian sign language": [
        7937
    ],
    "ukrayinska mova zhestiv": [
        7937
    ],
    "ukrayinska": [
        7937
    ],
    "ukrayinska zhestova mova": [
        7937
    ],
    "ukrayinskoyu zhestivoyu movoyu": [
        7937
    ],
    "ukrayinskoyu": [
        7937
    ],
    "ukpe": [
        7938,
        7941
    ],
    "ukpe-bayobiri": [
        7938
    ],
    "ukwa": [
        7939
    ],
    "urubú-kaapor sign language": [
        7940
    ],
    "urubú-kaapor": [
        7940,
        7993
    ],
    "ukue": [
        7941
    ],
    "ukwuani-aboh-ndoni": [
        7942
    ],
    "ula": [
        7944
    ],
    "ura": [
        8004,
        8031,
        7944
    ],
    "ulukwumi": [
        7945
    ],
    "ulch": [
        7946
    ],
    "ulcha": [
        7946
    ],
    "ulchi": [
        7946
    ],
    "ulych": [
        7946
    ],
    "ul’cha": [
        7946
    ],
    "usku": [
        7948
    ],
    "ulithian": [
        7949
    ],
    "ullatan": [
        7951
    ],
    "ulladan": [
        7951
    ],
    "ulumanda’": [
        7952
    ],
    "ulumanda'": [
        7952
    ],
    "ulumandak": [
        7952
    ],
    "ulunda": [
        7952
    ],
    "unserdeutsch": [
        7953
    ],
    "uma’ lung": [
        7954
    ],
    "uma’": [
        7954,
        8514
    ],
    "uma' lung": [
        7954
    ],
    "ulwa": [
        7955,
        8827
    ],
    "ulúa": [
        7955
    ],
    "umatilla": [
        7956
    ],
    "umbundu": [
        7957
    ],
    "umbundo": [
        7957
    ],
    "umbindhamu": [
        7959
    ],
    "umbuigamu": [
        7959
    ],
    "umpinthamu": [
        7959
    ],
    "umpithamu": [
        7959
    ],
    "uuku umpithamu": [
        7959
    ],
    "uuku": [
        7959
    ],
    "umbuygamu": [
        7960
    ],
    "umbuykamu": [
        7960
    ],
    "umpuykumu": [
        7960
    ],
    "ukit": [
        7961
    ],
    "umon": [
        7962
    ],
    "umotína": [
        7964
    ],
    "umutina": [
        7964
    ],
    "umpila": [
        7965
    ],
    "umbila": [
        7965
    ],
    "umbugarla": [
        7966
    ],
    "unangg": [
        7968
    ],
    "unank": [
        7968
    ],
    "undetermined": [
        7969
    ],
    "uneme": [
        7970
    ],
    "uleme": [
        7970
    ],
    "ungarinjin": [
        7971
    ],
    "ungarinyin": [
        7971
    ],
    "unami": [
        7974
    ],
    "unubahe": [
        7980
    ],
    "unoba’i": [
        7980
    ],
    "unde": [
        7984
    ],
    "unde kaili": [
        7984
    ],
    "umeda": [
        7985,
        8673
    ],
    "uripiv-wala-rano-atchin": [
        7986
    ],
    "undri": [
        7987,
        7988,
        7989
    ],
    "urudu": [
        7987,
        7988,
        7989
    ],
    "urarina": [
        7992
    ],
    "urningangg": [
        7994
    ],
    "uningangk": [
        7994
    ],
    "urningangga": [
        7994
    ],
    "urningangk": [
        7994
    ],
    "uru": [
        7995
    ],
    "uchumataqu": [
        7995
    ],
    "uradhi": [
        7996
    ],
    "urigina": [
        7997
    ],
    "uriginau": [
        7997
    ],
    "urhobo": [
        7998
    ],
    "urim": [
        7999
    ],
    "urak lawoi’": [
        8000
    ],
    "urak": [
        8000
    ],
    "urak lawoi'": [
        8000
    ],
    "urali": [
        8001,
        8670,
        8671,
        8672
    ],
    "uraly": [
        8001
    ],
    "urli": [
        8001
    ],
    "urapmin": [
        8002
    ],
    "urap": [
        8002
    ],
    "uruangnirin": [
        8003
    ],
    "ura (papua new guinea)": [
        8004
    ],
    "uramet": [
        8004
    ],
    "uramit": [
        8004
    ],
    "uramot": [
        8004
    ],
    "uramät": [
        8004
    ],
    "uru-pa-in": [
        8005
    ],
    "urat": [
        8007
    ],
    "urumí": [
        8008
    ],
    "uruava": [
        8009
    ],
    "usino": [
        8010
    ],
    "urimo": [
        8011
    ],
    "ulimo": [
        8011
    ],
    "uria": [
        8012
    ],
    "uru-eu-wau-wau": [
        8013
    ],
    "uru-eu-uau-uau": [
        8013
    ],
    "uruewawau": [
        8013
    ],
    "usarufa": [
        8014
    ],
    "usurufa": [
        8014
    ],
    "uturupa": [
        8014
    ],
    "ushojo": [
        8015
    ],
    "ushuji": [
        8015
    ],
    "usoi": [
        8016,
        8017
    ],
    "unshoi": [
        8016,
        8017
    ],
    "unsuiy": [
        8016,
        8017
    ],
    "ushoi": [
        8016,
        8017
    ],
    "usui": [
        8016,
        8017
    ],
    "usaghade": [
        8018
    ],
    "usakade": [
        8018
    ],
    "usakedet": [
        8018
    ],
    "uspanteko": [
        8019
    ],
    "uspanteco": [
        8019
    ],
    "us-saare": [
        8020
    ],
    "usu": [
        8021
    ],
    "utanga": [
        8022
    ],
    "utange": [
        8022
    ],
    "utank": [
        8022
    ],
    "ute-southern paiute": [
        8023
    ],
    "ute-southern": [
        8023
    ],
    "ute-chemehuevi": [
        8023
    ],
    "ut-hun": [
        8024
    ],
    "u̱t-hun": [
        8024
    ],
    "utupua": [
        8025
    ],
    "utur": [
        8026
    ],
    "utu": [
        8027
    ],
    "ura (vanuatu)": [
        8031
    ],
    "uvea": [
        8033,
        8265
    ],
    "uvean": [
        8033,
        8265
    ],
    "uri vehees": [
        8034
    ],
    "urii": [
        8034
    ],
    "uvol": [
        8035
    ],
    "uyanga": [
        8037
    ],
    "uzbek": [
        8038,
        8039,
        8040,
        8041,
        8042,
        8043,
        8044
    ],
    "usbaki": [
        8038,
        8039,
        8040,
        8042,
        8043
    ],
    "usbeki": [
        8038,
        8039,
        8040,
        8042,
        8043,
        8044
    ],
    "uzbek, northern": [
        8038,
        8039,
        8040,
        8042,
        8043
    ],
    "uzbek, southern": [
        8044
    ],
    "uzbak": [
        8044
    ],
    "umbarbarem": [
        8105
    ],
    "upper franconian": [
        8109
    ],
    "upper chinook": [
        8150
    ],
    "uapixana": [
        8163
    ],
    "uará": [
        8169
    ],
    "uaura": [
        8169
    ],
    "uaiuai": [
        8171
    ],
    "uaieue": [
        8171
    ],
    "upurui": [
        8173
    ],
    "uassi": [
        8181
    ],
    "ulperra": [
        8187
    ],
    "ukkia": [
        8217
    ],
    "upaa": [
        8224
    ],
    "uirafed": [
        8240
    ],
    "upper eel river": [
        8260
    ],
    "umbaia": [
        8272
    ],
    "umbule": [
        8275
    ],
    "uai ma’a": [
        8277
    ],
    "uai": [
        8277
    ],
    "uaimo’a": [
        8277
    ],
    "unamara": [
        8296
    ],
    "usan": [
        8299
    ],
    "uageo": [
        8306
    ],
    "unambal": [
        8361
    ],
    "usak": [
        8364
    ],
    "udung": [
        8368
    ],
    "urunjeri": [
        8384
    ],
    "uaiora": [
        8386
    ],
    "uptabi": [
        8409
    ],
    "urambal": [
        8468
    ],
    "unggumi": [
        8470
    ],
    "ungami": [
        8470
    ],
    "ungumi": [
        8470
    ],
    "usun apau kenyah": [
        8502
    ],
    "usun": [
        8502
    ],
    "umbewaha": [
        8508
    ],
    "uma’ lasan": [
        8514
    ],
    "uma' lasan": [
        8514
    ],
    "urali kurumba": [
        8670,
        8671,
        8672
    ],
    "umiida": [
        8673
    ],
    "umede": [
        8673
    ],
    "umida": [
        8673
    ],
    "umidi": [
        8673
    ],
    "umbrian": [
        8677,
        8678
    ],
    "unggaranggu": [
        8679
    ],
    "ungarangi": [
        8679
    ],
    "ungaranji": [
        8679
    ],
    "unggarangi": [
        8679
    ],
    "unggarrangu": [
        8679
    ],
    "upper umpqua": [
        8681
    ],
    "urartian": [
        8682
    ],
    "unungun": [
        8713
    ],
    "uhumkhegi": [
        8754
    ],
    "uhumkiji": [
        8754
    ],
    "uuhum": [
        8754
    ],
    "uuhum-gigi": [
        8754
    ],
    "ubuvala": [
        8848
    ],
    "uchean": [
        8921
    ],
    "uchi": [
        8921
    ],
    "upland yuman": [
        8927
    ],
    "upland": [
        8927
    ],
    "upper colorado river yuman": [
        8927
    ],
    "uruwa": [
        8939
    ],
    "unat": [
        8943
    ],
    "ulu muar malay": [
        9089
    ],
    "unknown": [
        9189
    ]
};
